module.exports = __webpack_public_path__ + "img/swyl.98ed2ca.png";